// CATEGORIAS
export const UnidadMedidaPeso = [
	'kg', // "mg", "g", "kg", "libra", "onza"
	'g',
	'mg',
	'libra',
	'onza',
];

export const UnidadMedidaM = [
	'mm', // "mm", "cm", "ft", "in"   // "ft" -> Pie    // in -> Pulgadas
	'cm',
	'ft',
	'in',
];

export const CantidadPallets = ['1', '2', '3', '4', '5', '6', '7'];
